import {
    updateCartTotals,
    validateBasket,
    updateApproachingDiscounts,
    updateCartComponents
} from 'base_global/cart/cartCustomService';
var handleReward = require('./handleReward');
var tealiumEnable = require('int_tealium_sfra/tealiumEnable');
var utils = require('base_global/utils');

export default class Reward {
    // initialized on load
    constructor() {
        this.onLoadReward();
    }
    initializePaymentMethods(totals) {
        if ($('#checkout-main').length && ($('#checkout-main').attr('data-checkout-stage') === 'payment')) {
            var summaryHelpers = require('base_global/checkout/summary');
            var adyenCheckout = require('adyen_custom/adyen/checkout');
            summaryHelpers.updateTotals(totals);
            adyenCheckout.init();
        }
    }

    onLoadReward() {
        var self = this;
        $(document).ready(function () {
            var $rewardSections = $('.available-rewards .reward-section');
            var $showmorerewards = $('.show_more_rewards');
            $rewardSections.each(function (index) {
                if ($(this).hasClass('disabled')) {
                    $('.reward_unavailable_title').removeClass('d-none');
                } else if (!$(this).hasClass('disabled')) {
                    if (index > 2) {
                        $showmorerewards.removeClass('d-none');
                        $(this).addClass('d-none');
                    }
                }
            });

            $showmorerewards.click(function () {
                $rewardSections.removeClass('d-none');
                $(this).addClass('d-none');
            });
            handleReward.handleCheckboxState();
            // reward selection cap
            handleReward.handleRewardLimitBreached();
            $(document).on('click', '.checkbox_reward', function () {
                $.spinner().start();
                var pageType = $('.page').data('page') || 'cart';
                var $this = $(this);
                var $noReward = $('.no_reward');
                $('.available-rewards .page-error').remove();
                if ($this.is(':checked') && !$this.hasClass('no_reward')) {
                    var inputData = {
                        couponCode: $this.attr('data-rewardid'),
                        csrf_token: $('.csrf').val(),
                        transactionId: $this.attr('data-transactionid'),
                        rewardAmount: $this.attr('data-rewardAmount'),
                        rewardName: $this.attr('data-rewardName')
                    };
                    var redeemUrl = $('.available-rewards').data('redeemrewardurl');
                    $.ajax({
                        type: 'GET',
                        url: redeemUrl,
                        data: inputData,
                        success: function (data) {
                            if (data.error) {
                                $this.prop('checked', false);
                                $('.reward-custom-message').html(data.errorMessage);
                                if (data.rewardsApplyError) {
                                    $('.available-rewards').append(`<div class="page-error mb-0 mt-1" role="alert"><div><svg class="icon-utility-alert-red"><use xlink:href="#alert-red"></use></svg></div><div class="message">${data.rewardsApplyError}</div></div>`);
                                }
                                if ($noReward.length) {
                                    $noReward.prop('checked', true);
                                }
                                tealiumEnable.getAnalyticsData('serverError', data.errorCode);
                            } else {
                                if ($('.js-product--list').length) {
                                    if (data.items.length) {
                                        $('.js-product--list').html(data.renderTemplate);
                                    } else {
                                        const $targetContainer = $('.emptycart-ooslist');
                                        $targetContainer.html(data.renderTemplate);
                                        const $cartPage = $('.cart');
                                        $cartPage.removeClass('has-cart-items, cart-page');
                                        $('.shipping--intro').addClass('d-none');
                                        $cartPage.addClass('cart-empty');
                                    }
                                    updateCartComponents(data);
                                }
                                if (!$('.coupons-and-promos').length) {
                                    $('body').append('<div class="coupons-and-promos"></div>');
                                }
                                $('.rewards-redeem-error').remove();
                                updateCartTotals(data);
                                updateApproachingDiscounts(data.approachingDiscounts);
                                validateBasket(data);
                                self.initializePaymentMethods(data.totals);
                                handleReward.handleCheckboxState();
                                $this.prop('checked', true);
                                handleReward.rewardsResponse(data);
                                // Antavo Loyalty start
                                if (data.antavoRewardPoints && data.antavoRewardPoints.points >= 0) {
                                    $('.tooltip-wrapper .tooltip-points').empty().append('Members earn points ' + data.antavoRewardPoints.points + ' Preferred Loyalty points on this purchase.');
                                    $('.loyalty-info-message-points').val(data.antavoRewardPoints.points);
                                    $('.reward-earned-payment').html(data.antavoRewardPoints.points);
                                    $('.order-summary-container .loyalty-rewards-box-model-cart .points-display, .device-summary-msg .loyalty-rewards-box-model-cart .points-display').html(data.antavoRewardPoints.points);

                                    $('.order-summary-container, .device-loyalty-pointscontainer').removeClass('hide-antavo-copy');
                                    if ($('.loyalty-info-message .checkout-loyaltyrewards-container').length) {
                                        $('.loyalty-info-message .checkout-loyaltyrewards-container').removeClass('hide-antavo-copy');
                                    }
                                    if (data.antavoRewardPoints.points === 0) {
                                        $('.order-summary-container, .device-loyalty-pointscontainer').addClass('hide-antavo-copy');
                                        if ($('.loyalty-info-message .checkout-loyaltyrewards-container').length) {
                                            $('.loyalty-info-message .checkout-loyaltyrewards-container').addClass('hide-antavo-copy');
                                        }
                                    }
                                }
                                // reward selection cap
                                handleReward.handleRewardLimitState();
                            }
                            if (pageType === 'cart') {
                                utils.uniformSpacing();
                            }
                            $.spinner().stop();
                        },
                        error: function (data) {
                            $this.prop('checked', true);
                            $('.reward-custom-message').html(data.errorMessage);
                            $.spinner().stop();
                        }
                    });
                } else {
                    var removeUrl = $('.available-rewards').data('removerewardurl');
                    var removeData = {};
                    var checkoutWrapper = $('#checkout-wrapper');
                    if (checkoutWrapper.length) {
                        var urlParams = {
                            pageType: checkoutWrapper.attr('data-pageType')
                        };
                        removeUrl = utils.appendToUrl(removeUrl, urlParams);
                    }
                    if ($this.hasClass('no_reward')) {
                        removeData = {
                            removeLoyaltycoupons: true
                        };
                    } else {
                        removeData = {
                            code: $(this).attr('data-rewardid'),
                            uuid: $(this).attr('data-uuid'),
                            isRewardCoupon: $(this).attr('data-isloyalty')
                        };
                    }
                    $.ajax({
                        type: 'GET',
                        url: removeUrl,
                        data: removeData,
                        success: function (data) {
                            if (data.error) {
                                $this.prop('checked', true);
                                $('.reward-custom-message').html(data.errorMessage);
                            } else {
                                if ($('.js-product--list').length) {
                                    if (data.items.length) {
                                        $('.js-product--list').html(data.renderTemplate);
                                    } else {
                                        const $targetContainer = $('.emptycart-ooslist');
                                        $targetContainer.html(data.renderTemplate);
                                        const $cartPage = $('.cart');
                                        $cartPage.removeClass('has-cart-items, cart-page');
                                        $('.shipping--intro').addClass('d-none');
                                        $cartPage.addClass('cart-empty');
                                    }
                                    updateCartComponents(data);
                                }
                                updateCartTotals(data);
                                updateApproachingDiscounts(data.approachingDiscounts);
                                validateBasket(data);
                                self.initializePaymentMethods(data.totals);
                                $this.prop('checked', false);
                                if ($noReward.length) {
                                    $noReward.prop('checked', true);
                                }
                                // Antavo Loyalty start
                                if (data.antavoRewardPoints && data.antavoRewardPoints.points >= 0) {
                                    $('.tooltip-wrapper .tooltip-points').empty().append('Members earn points ' + data.antavoRewardPoints.points + ' Preferred Loyalty points on this purchase.');
                                    $('.loyalty-info-message-points').val(data.antavoRewardPoints.points);
                                    $('.reward-earned-payment').html(data.antavoRewardPoints.points);
                                    $('.order-summary-container .loyalty-rewards-box-model-cart .points-display, .device-summary-msg .loyalty-rewards-box-model-cart .points-display').html(data.antavoRewardPoints.points);
                                    $('.order-summary-container, .device-loyalty-pointscontainer').removeClass('hide-antavo-copy');
                                    if ($('.loyalty-info-message .checkout-loyaltyrewards-container').length) {
                                        $('.loyalty-info-message .checkout-loyaltyrewards-container').removeClass('hide-antavo-copy');
                                    }
                                    if (data.antavoRewardPoints.points === 0) {
                                        $('.order-summary-container, .device-loyalty-pointscontainer').addClass('hide-antavo-copy');
                                        if ($('.loyalty-info-message .checkout-loyaltyrewards-container').length) {
                                            $('.loyalty-info-message .checkout-loyaltyrewards-container').addClass('hide-antavo-copy');
                                        }
                                    }
                                }
                            }
                            handleReward.rewardsResponse(data);
                            // reward selection cap
                            handleReward.handleRewardLimitState();
                            if (pageType === 'cart') {
                                utils.uniformSpacing();
                            }
                            $.spinner().stop();
                        },
                        error: function (data) {
                            $this.prop('checked', true);
                            $('.reward-custom-message').html(data.errorMessage);
                            $.spinner().stop();
                        }
                    });
                }
            });

            $(document).on('change', '.deselect-rewards', function (e) {
                e.preventDefault();
                $('.checkbox_reward:checked').each(function () {
                    // $(this).prop('checked', false).trigger('click');
                    $(this).trigger('click');
                });
                const $noReward = $('.no_reward');
                if ($noReward.length) {
                    $('.no_reward').prop('checked', true).trigger('click');
                }
            });
        });
    }
}
